import { render, staticRenderFns } from "./omsethitungan.vue?vue&type=template&id=1abed4fa"
import script from "./omsethitungan.vue?vue&type=script&lang=js"
export * from "./omsethitungan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports